import { Pagination } from "@mui/material";
import CustomButton from "../../../Components/Atoms/CustomButton";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import { postExcelUploadRecordsVisitorLogRequest } from "../../../Redux/VisitorLogs/VisitorLogsActions";

const ImportExcelRecords = ({ handleClose }) => {
  const { postExcelVisitorLogResponse, postExcelDataVisitorLogLoading } =
    useSelector((state) => state.visitorLogReducer);

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  const totalPages = Math.ceil(
    postExcelVisitorLogResponse?.data?.data?.length / itemsPerPage,
  );

  const paginatedData = postExcelVisitorLogResponse?.data?.data?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const diapatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      data: postExcelVisitorLogResponse?.data?.data,
    },
    onSubmit: (values) => {
      diapatch(
        postExcelUploadRecordsVisitorLogRequest({
          ...values,
        }),
      );
    },
  });
  console.log(paginatedData, "paginatedData");
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="tblWrpr">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  {postExcelVisitorLogResponse?.data?.columns?.map(
                    (col, index) => (
                      <th key={index}>{col}</th>
                    ),
                  )}
                </tr>
              </thead>
              <tbody>
                {paginatedData?.map((row, index) => (
                  <tr key={index}>
                    {postExcelVisitorLogResponse?.data?.columns?.map(
                      (col, colIndex) => (
                        <td key={colIndex}>{row[col]}</td>
                      ),
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="d-flex-juscon-sb-align-center mt-5 mb-5">
            <div></div>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              size="small"
              variant="outlined"
              shape="rounded"
            />
          </div>
        </div>

        <div className="btnActnBar">
          <CustomButton
            label={"Cancel"}
            btnType="secondary"
            onClick={handleClose}
            action={"CANCEL"}
          />
          <CustomButton
            type={"submit"}
            label={postExcelDataVisitorLogLoading ? "Loading..." : "Upload"}
            action={"UPLOAD"}
          />
        </div>
      </form>
    </>
  );
};
export default ImportExcelRecords;
